// Import model
import { ObjectType } from '../models/ObjectType';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ObjectType - handles JSON serialization and deserialization with type validation
 */
export class ObjectTypeSerializer {
  /**
   * Deserializes a JSON string into a ObjectType instance
   */
  static deserialize(json: string): ObjectType {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ObjectType instance
   */
  static fromObject(obj: any): ObjectType {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ObjectType');
    }


    const instance: ObjectType = {
      name: obj['Name'] as string | undefined,
      fullName: obj['FullName'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ObjectType instances
   */
  static deserializeArray(json: string): ObjectType[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ObjectType instance to a JSON string
   */
  static serialize(instance: ObjectType): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ObjectType instance to a plain object
   */
  static toObject(instance: ObjectType): any {
    return {
      'Name': instance.name,
      'FullName': instance.fullName,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of ObjectType instances to a JSON string
   */
  static serializeArray(instances: ObjectType[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
